module.exports = __webpack_public_path__ + "static/media/Example of Departments.4603eeaf.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Departments.csv
// module id = 709
// module chunks = 0